import { computed } from 'vue';
import { useStore } from 'vuex';
import { language } from "../language";
import {
  collectInfo,
  commonAnswerInfo,
  singleEditInfo,
  checkTips,
} from './answerHook';
export default function () {
  const store = useStore();
  const chooseAnswer = computed(() => store.state.survey.chooseAnswer);
  const matrixAnswer = computed(() => store.state.survey.matrixAnswer);
  const titleConfig = computed(
    () => store.getters['survey/currentTitleConfig']
  );
  const currentAnswerConfig = computed(
    () => store.getters['survey/currentAnswerConfig']
  );
  // 检测各个题型的必答情况
  const commonCheckMust = type => {
    const checkMustMap = {
      common:
        chooseAnswer.value.length > 0 &&
        chooseAnswer.value.every(item => item >= 0),
      matrix:
        matrixAnswer.value.length > 0 &&
        matrixAnswer.value.every(item => item >= 0),
      cloze: singleEditInfo.value.length > 0,
    };
    if (titleConfig.value.must && !checkMustMap[type]) {
      checkTips.value = language.getTextByKey('mustAnswer');
      return false;
    }
    return true;
  };
  const checkMap = {
    singleChoose: () => {
      if (!commonCheckMust('common')) {
        return false;
      }
      let chooseIndex = chooseAnswer.value[0];
      let mustEdit = currentAnswerConfig.value[chooseIndex]?.allowEdit && currentAnswerConfig.value[chooseIndex]?.mustEdit;
      if (mustEdit && !commonAnswerInfo.value[chooseIndex]?.edit?.length) {
        // 存在选项填空必填 + 为满足条件
        checkTips.value = language.getTextByKey('mustWrite');
        return false;
      }
      return true;
    },
    multipleChoose: () => {
      if (!commonCheckMust('common')) {
        return false;
      }
      if (!titleConfig.value.must && chooseAnswer.value.length === 0) { // 非必答且未作答
        return true;
      }
      // 检查是否选了互斥选项, 仅针对非互斥选项做数量校验
     let hasMutex =  chooseAnswer.value.some(answerIndex => {
        return currentAnswerConfig.value.list[answerIndex].mutex === true
      })
      let minChooseCount = currentAnswerConfig.value.minChooseCount;
      let maxChooseCount = currentAnswerConfig.value.maxChooseCount;
      // 非互斥 + 有最小个数要求 + 不满足条件
      if (!hasMutex && minChooseCount && (chooseAnswer.value.length < minChooseCount)) {
        checkTips.value = language.getTextByKey('maxChoose').replace('xxx', minChooseCount);
        return false;
      }
      // 非互斥 + 有最大个数要求 + 不满足条件
      if (!hasMutex && maxChooseCount && (chooseAnswer.value.length > maxChooseCount)) {
        checkTips.value = language.getTextByKey('leastChoose').replace('xxx', maxChooseCount);
        return false;
      }
      // 存在选项填空必填 + 不满足条件
      let editConditionPass = chooseAnswer.value.every(answerIndex => {
        let mustEdit = currentAnswerConfig.value.list[answerIndex]?.allowEdit && currentAnswerConfig.value.list[answerIndex]?.mustEdit;
        return mustEdit
          ? commonAnswerInfo.value[answerIndex]?.edit?.length > 0
          : true;
      });
      if (!editConditionPass) {
        checkTips.value = language.getTextByKey('mustWrite');
        return false;
      }
      return true;
    },
    cloze: () => {
      if (!commonCheckMust('cloze')) {
        return false;
      }
      // 非必答 + 未作答
      if (!titleConfig.value.must && singleEditInfo.value.length === 0) {
        return true;
      }
      let isLimitCount = currentAnswerConfig.value.isLimitCount;
      let minCount = currentAnswerConfig.value.minCount;
      let maxCount = currentAnswerConfig.value.maxCount;
      // 有最小字数要求 + 不满足条件
      if (isLimitCount && singleEditInfo.value.length < minCount) {
        checkTips.value = language.getTextByKey('leastWord').replace('xxx', minCount);
        return false;
      }
      // 有最大字数要求 + 不满足条件
      if (isLimitCount && singleEditInfo.value.length > maxCount) {
        checkTips.value = language.getTextByKey('maxWord').replace('xxx', maxCount);
        return false;
      }
      return true;
    },
    messageCollect: () => {
      let editConditionPass = currentAnswerConfig.value.every(message => {
        let messageMust = message.must;
        let collectValue =
          message.collectType === 'phone'
            ? collectInfo.value.phone
            : collectInfo.value.email;
        if (!messageMust && collectValue?.length === 0) {
          return true;
        }
        if (message.collectType === 'phone') {
          // 检测号码规则
          let phoneCodeObjectArr = message.ext.phoneCodeArr.map(item =>
            JSON.parse(item)
          );
          let limitArr =
            phoneCodeObjectArr.find(
              item => +item.code === +collectInfo.value.phoneArea
            )?.limit || [];

          let checkLimit = limitArr.some(
            num => collectInfo.value.phone?.length === +num
          );
          if (!checkLimit) {
            checkTips.value = language.getTextByKey('checkPhone');
            return false;
          }
        }
        if (message.collectType === 'email') {
          // 检测邮箱规则
          let emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
          if (!emailReg.test(collectValue)) {
            checkTips.value = language.getTextByKey('checkEmail');
            return false;
          }
        }
        return collectValue?.length > 0;
      });
      if (!editConditionPass) {
        return false;
      }
      return true;
    },
    matrixSingle: () => {
      if (!commonCheckMust('matrix')) {
        return false;
      }
      let answerConfig = currentAnswerConfig.value.chooseArray;
      // 存在选项填空必填 + 无满足条件
      let editConditionPass = matrixAnswer.value.every(
        (matrixIndex, rowIndex) => {
          let matrixEdit = answerConfig[matrixIndex]?.allowEdit && answerConfig[matrixIndex]?.mustEdit;
          return matrixEdit
            ? commonAnswerInfo.value[rowIndex]?.edit?.length > 0
            : true;
        }
      );
      if (!editConditionPass) {
        checkTips.value = language.getTextByKey('mustWrite');
        return false;
      }
      return true;
    },
    matrixProgress: () => {
      return commonCheckMust('matrix');
    },
    NPS: () => {
      return commonCheckMust('common');
    },
  };
  return {
    checkMap,
    titleConfig,
  };
}
